/*
 * LoginForm/Passwordless Messages
 *
 * This contains all the text for the Passwordless component.
 */

import { defineMessages } from 'react-intl'

export const scope = 'app.components.LoginFormPasswordless'

export default defineMessages({
	header: {
		id: `${scope}.header`,
		defaultMessage: 'This is the LoginFormPasswordless component!',
	},
})
